import BaseComponent from "../../../base/base_component";
import {GermanyResponsibleGamingButtonPlacement} from "../../../../../common/const/responsible-gaming";

export default class GermanyResponsibleGamingIconsController extends BaseComponent {
  static CLASS = 'GermanyResponsibleGamingIconsController';
    _placement:GermanyResponsibleGamingButtonPlacement;

    init(params) {
        super.init(params);
        this._placement = params.placement;
    }

  start(){
      this.serviceFactory.orbitComponentRenderService().renderGermanyResponsibleGamingButtons(this.getEl(), {placement:this._placement});
    return this;
  }
}